import NoiseRemote from "./NoiseRemote";
import { sendNoise } from "src/pods/noise";
import { ErrorType } from "src/pods/noise/data/errorMessages";
import { useToolkitNoiseStore } from "src/pods/noise/toolkitNoiseStore";
import { displayOpen, displayClose, remoteClose } from "src/pods/realtime";
import { useToolkitRealtimeStore } from "src/pods/realtime/toolkitRealtimeStore";
import { dispatchToolkitReduxAction } from "src/state/toolkitReduxStore";

type NoiseRemoteContainerProps = {
  params: {
    classId: string;
    mountPoint: string;
  };
};

export default function NoiseRemoteContainer({ params }: NoiseRemoteContainerProps) {
  const { displayOn: isCasting, paired: isConnected } = useToolkitRealtimeStore();
  const { microphonePermissionErrorName } = useToolkitNoiseStore();

  return (
    <NoiseRemote
      classId={params.classId}
      mountPoint={params.mountPoint}
      isCasting={isCasting}
      isConnected={isConnected}
      microphonePermissionErrorName={microphonePermissionErrorName as ErrorType}
      displayOpen={(path, action) => dispatchToolkitReduxAction(displayOpen(path, action))}
      displayClose={() => dispatchToolkitReduxAction(displayClose())}
      remoteClose={() => dispatchToolkitReduxAction(remoteClose())}
      sendNoise={(payload) => dispatchToolkitReduxAction(sendNoise(payload))}
    />
  );
}
